class Faq {

    constructor(el, options) {
        this.el = el;
        this.init();
    }

    init() {
        this.el.querySelectorAll('[data-item]').forEach((el) => {
            this.collapseItem(el);
        });

        this.el.querySelectorAll('[data-toggle]').forEach((el) => {
            el.addEventListener('click', (e) => {
                this.toggleItem(e.currentTarget);
                e.preventDefault();
            });
        });
    }

    // get nearest parent element matching selector
    _closest(el, selector) {
        var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

        while (el) {
            if (matchesSelector.call(el, selector)) {
                break;
            }
            el = el.parentElement;
        }
        return el;
    }

    // track using Google Analytics datalayer push
    _track(item) {
        var event = item.classList.contains('-collapsed') ? "closeFaqItem" : "openFaqItem";
        var action = item.classList.contains('-collapsed') ? "Close" : "Open";
        var label = item.querySelector("h3").innerText;

        if (typeof(dataLayer) === "object") {
            dataLayer.push(
                {
                    'event': event,
                    'eventName': 'faq_click',
                    'faq_status': action.toLowerCase(),
                    'faq_name': label,
                    'eventCategory': 'FAQ',
                    'eventAction': action,
                    'eventLabel': label
                }
            );
        }
    }


    collapseItem(el) {
        el.classList.toggle('-collapsed');
    }

    toggleItem(el) {
        var item = this._closest(el, '[data-item]');
        item.classList.toggle('-collapsed');

        this._track(item);
    }

}

export { Faq as Faq };
